import { render, staticRenderFns } from "./Our_Identity.vue?vue&type=template&id=21ba59f2&scoped=true&"
import script from "./Our_Identity.vue?vue&type=script&lang=js&"
export * from "./Our_Identity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ba59f2",
  null
  
)

export default component.exports